module.exports = __webpack_public_path__ + "static/media/grace-mao.616aaf6f.jpg";